"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemVideo = void 0;
var _react = _interopRequireWildcard(require("react"));
var _videoBg = _interopRequireDefault(require("b2b-components/theme/assets/images/video-bg.png"));
var _common = require("b2b-components/theme/common");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ItemVideo = _ref => {
  let {
    isAutoplay,
    registerVideoStopObject,
    video,
    itemIndex,
    title
  } = _ref;
  const iframeElement = (0, _react.useRef)(null);
  const url = new URL(video.link);
  isAutoplay ? url.searchParams.append('autoplay', '1') : !!url.searchParams.get('autoplay') && url.searchParams.delete('autoplay');
  (0, _react.useEffect)(() => {
    registerVideoStopObject?.({
      onStop: () => {
        if (iframeElement.current) {
          const src = iframeElement.current.getAttribute('src') || '';
          const url = new URL(src);
          iframeElement.current?.setAttribute('src', url.href);
        }
      },
      videoIndex: itemIndex || 0
    });
  });
  const isVimeo = video.type === _common.VIDEO_TYPE.vimeo;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Gallery-ItemVideoWrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Gallery-ItemVideoIframe"
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    allow: "autoplay",
    allowFullScreen: isVimeo,
    frameBorder: "0"
    // @ts-ignore
    ,
    mozallowfullscreen: isVimeo,
    ref: iframeElement,
    src: url.href,
    title: `${title} - video ${itemIndex || ''}`,
    webkitallowfullscreen: isVimeo
  })), /*#__PURE__*/_react.default.createElement("img", {
    alt: title,
    className: "cds-Gallery-ItemVideoImg",
    src: _videoBg.default,
    title: title
  }));
};
exports.ItemVideo = ItemVideo;
//# sourceMappingURL=ItemVideo.js.map